import type {
  RequestPasswordResetCommand,
  RequestPasswordResetResult,
} from "../model/PasswordReset";
import type { PasswordResetService } from "../port/PasswordResetService";

export class RequestPasswordReset {
  constructor(private readonly service: PasswordResetService) {}

  execute(
    cmd: RequestPasswordResetCommand,
    signal?: AbortSignal,
  ): Promise<RequestPasswordResetResult> {
    return this.service.requestPasswordReset(cmd, signal);
  }
}
